//loading
export const showLoading = (state) => {
  state.LOADING = true
}
export const hideLoading = (state) => {
  state.LOADING = false
}